const fourDigitRegex = /^\d{4}$/;
const fiveDigitRegex = /^\d{5}$/;
const REGEX = {
    EMAIL_ADDRESS: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    TEXT: /^[a-zA-Z\u00C0-\u00ff .-]*$/,
    TEXT_WITH_APOSTROPHE: /^[\u00C0-\u017Fa-zA-Z'’‘’][\u00C0-\u017Fa-zA-Z’‘’' -]+[\u00C0-\u017Fa-zA-Z'’‘’]?$/,
    DIGIT_LEADING_WHITESPACE: /.+\s\d+(?:\s?[A-Za-z]|[\/\-]\d+)?\b/,
    ADDRESS_LINE: /^[a-zA-Z\u00C0-\u00ff\u2018\u20190-9 .,'’’\/\-]*$/,
    ALPHANUMERIC: /^[a-zA-Z0-9 ]*$/,
    LEADING_ALPHABETIC: /^(?!\d+$)(?=[^ ]*\p{L})[^ ]+/u,
    NOT_LEADING_WHITESPACE: /^[^\s]+(\s.*)?$/,
    CONTAINS_DOT: /\./,
    ORDER_NUMBER: /^([A-Za-z0-9]{8,10})$/,
    BE: /^(?:(?:[1-9])(?:\d{3}))$/,
    NL: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i,
    GB: /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i,
    IT: fiveDigitRegex,
    DK: /^(?:[1-24-9]\d{3}|3[0-8]\d{2})$/,
    SE: /^\d{3}\s?\d{2}/,
    PT: /^\d{4}-\d{3}$/,
    IE: /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ ]?[0-9AC-FHKNPRTV-Y]{4}$/i,
    ES: fiveDigitRegex,
    FR: /^(0[1-9]|[1-8]\d|9[0-6])\d{3}$/,
    AT: fourDigitRegex,
    BG: fourDigitRegex,
    CY: /^(\d{2}|\d{4})$/,
    HR: fiveDigitRegex,
    CZ: fiveDigitRegex,
    EE: fiveDigitRegex,
    DE: fiveDigitRegex,
    GR: fiveDigitRegex,
    HU: fourDigitRegex,
    FI: fiveDigitRegex,
    LU: fourDigitRegex,
    LV: /^LV-\d{4}$/,
    LT: fiveDigitRegex,
    MT: /^[A-Z]{3}\s\d{4}$/,
    PL: /^\d{2}-\d{3}$/,
    SK: /^\d{3}\s?\d{2}$/,
    SI: fourDigitRegex,
    RO: /^\d{6}$/,
    US: /^\d{5}(-\d{4})?$/,
    CH: fourDigitRegex
};
const DATES_RANGE = {
    DAY: {
        min: 1,
        max: 31
    },
    MONTH: {
        min: 1,
        max: 12
    },
    YEAR_OF_BIRTH: {
        min: 1900,
        get max () {
            return new Date().getFullYear();
        }
    }
};
const isRequired = (value)=>{
    return value !== '';
};
const getPostalCodeRegex = (country)=>REGEX[country]
;
const isValidPostalCodeForCountry = (country, postalCode)=>{
    const regex = getPostalCodeRegex(country);
    return regex !== undefined && regex.test(postalCode);
};
const isNumber = (value)=>{
    const parsed = parseFloat(value);
    return !isNaN(parsed) && isFinite(parsed);
};
const isInteger = (value)=>{
    const parsed = parseInt(value);
    return Number.isInteger(parsed);
};
const isPositiveInteger = (value)=>{
    return isInteger(value) && Number(value) > 0;
};
const isNotDecimalNumber = (value)=>{
    return !REGEX.CONTAINS_DOT.test(value) && isPositiveInteger(value);
};
const isText = (value)=>{
    return REGEX.TEXT.test(value);
};
const isTextWithApostrophe = (value)=>{
    return REGEX.TEXT_WITH_APOSTROPHE.test(value);
};
const isAddressLine = (value)=>{
    return REGEX.ADDRESS_LINE.test(value);
};
const isAlphanumeric = (value)=>{
    return REGEX.ALPHANUMERIC.test(value);
};
const hasDigitLeadingWhitespace = (value)=>{
    return REGEX.DIGIT_LEADING_WHITESPACE.test(value);
};
const isLeadingAlphabetic = (value)=>{
    return REGEX.LEADING_ALPHABETIC.test(value);
};
const isStreetNameWithHouseNumber = (value)=>{
    return isAddressLine(value) && isLeadingAlphabetic(value) && hasDigitLeadingWhitespace(value);
};
const isEmailAddress = (value)=>{
    return REGEX.EMAIL_ADDRESS.test(value);
};
const isInRange = (value, from, to)=>{
    return value >= from && value <= to;
};
const isValidMonth = (value)=>{
    if (!DATES_RANGE.MONTH) return false;
    return isNumber(value) && value.length <= 2 && isInRange(Number(value), DATES_RANGE.MONTH.min, DATES_RANGE.MONTH.max);
};
const isValidDay = (value)=>{
    if (!DATES_RANGE.DAY) return false;
    return isNumber(value) && value.length <= 2 && isInRange(Number(value), DATES_RANGE.DAY.min, DATES_RANGE.DAY.max);
};
/**
 * @description
 * Validator to check Allow current year to 200 years in the past - up to 100 years in the future.
 * E.g. if the current year is 2025, the valid years are 1825 to 2025 to 2125.
 * Any year less than 1825 or greater than 2125 will be considered invalid.
 */ const isValidYear = (value)=>{
    // Accept only 4 digits in a year format
    if (!fourDigitRegex.test(value)) return false;
    const year = parseInt(value, 10);
    const currentYear = new Date().getFullYear();
    return isInRange(Number(year), currentYear - 200, currentYear + 100);
};
const isValidBirthDateYear = (value)=>{
    if (!DATES_RANGE.YEAR_OF_BIRTH) return false;
    return isNumber(value) && isInRange(Number(value), DATES_RANGE.YEAR_OF_BIRTH.min, DATES_RANGE.YEAR_OF_BIRTH.max);
};
const isDate = (value)=>{
    const [yyyy, mm, dd] = value.split('-');
    if (!yyyy || !mm || !dd) return false;
    return isValidDate(dd, mm, yyyy);
};
const isDateOfBirth = (value)=>{
    const [yyyy, mm, dd] = value.split('-');
    if (!yyyy || !mm || !dd) return false;
    return isValidBirthDate(dd, mm, yyyy);
};
const isValidDate = (dd, mm, yyyy)=>{
    const dateObject = new Date(`${yyyy}/${mm}/${dd}`);
    return !isNaN(dateObject.getTime()) && dateObject.getDate() === parseInt(dd);
};
const isValidBirthDate = (dd, mm, yyyy)=>{
    if (!isValidDate(dd, mm, yyyy) || !isValidBirthDateYear(yyyy)) {
        return false;
    }
    const birthDate = new Date(`${yyyy}/${mm}/${dd}`);
    const today = new Date();
    return birthDate <= today;
};
const isOlderThan = (ageRestriction)=>(value)=>{
        try {
            const today = new Date();
            const birthDate = new Date(value.replace(/-/g, '/')) // replace '-' with '/' because safari can't take it.
            ;
            const monthsLeft = today.getMonth() - birthDate.getMonth();
            let age = today.getFullYear() - birthDate.getFullYear();
            if (monthsLeft < 0 || monthsLeft === 0 && today.getDate() < birthDate.getDate()) {
                age--;
            }
            return age >= ageRestriction;
        } catch (error) {
            return false;
        }
    }
;
/**
 * @description
 * Validator to check if the given year is in the future up to the specified number of years.
 * E.g. if the current year is 2025 and the restriction is 3, the valid years are 2025, 2026, 2027, and 2028.
 * Any year greater than 2028 will be considered invalid.
 */ const isYearInRange = (yearRestriction)=>(value)=>{
        const currentYear = new Date().getFullYear();
        const inputYear = parseInt(value, 10);
        return inputYear >= currentYear && inputYear <= currentYear + yearRestriction;
    }
;
// Min/Max/Exact length string validators
const minLength = (minLength1)=>(value)=>{
        return typeof value === 'string' && value.length >= minLength1;
    }
;
const maxLength = (maxLength1)=>(value)=>{
        return typeof value === 'string' && value.length <= maxLength1;
    }
;
const exactLength = (length)=>(value)=>{
        return typeof value === 'string' && value.length === length;
    }
;
const isNotLeadingWhitespace = (value)=>{
    return REGEX.NOT_LEADING_WHITESPACE.test(value);
};
const isOrderNumber = (value)=>{
    return REGEX.ORDER_NUMBER.test(value);
};
const isApolloOrderNumber = (value)=>{
    const OPCOREGEX = {
        ORDER_NUMBER: /^(OR(88|99)-)?([A-Za-z0-9]{8,10})$/
    };
    return OPCOREGEX.ORDER_NUMBER.test(value);
};

export { DATES_RANGE, exactLength, getPostalCodeRegex, hasDigitLeadingWhitespace, isAddressLine, isAlphanumeric, isApolloOrderNumber, isDate, isDateOfBirth, isEmailAddress, isInRange, isInteger, isLeadingAlphabetic, isNotDecimalNumber, isNotLeadingWhitespace, isNumber, isOlderThan, isOrderNumber, isPositiveInteger, isRequired, isStreetNameWithHouseNumber, isText, isTextWithApostrophe, isValidBirthDate, isValidBirthDateYear, isValidDate, isValidDay, isValidMonth, isValidPostalCodeForCountry, isValidYear, isYearInRange, maxLength, minLength };
//# sourceMappingURL=validations.js.map
